export default "__VITE_ASSET__DPJi6rxo__"